import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import {  } from "react-router-dom";
import { DefaultLayout } from "../../layouts/Default";
import { Main } from "../../themes/Default/components/Main";
import { Title } from "../../themes/Default/components/Title";
import { TopNavigation } from "../../themes/Default/components/TopNavigation";
import { Breadcrumps } from "../../themes/Default/components/Breadcrumps";
import { Link } from "../../themes/Default/components/Breadcrumps/components/Link";
import { ButtonsPanel } from "../../themes/Default/components/ButtonPanel";
import { useTranslation } from "react-i18next";
import { useUserToken } from "../../hooks/core/UserToken";
import { roles } from "../../services/utils/Roles";


const Settings = () => {
    const navigate = useNavigate();
    const { t } = useTranslation("common");
    
    const buttons = [
        { title: t('settings.default'), icon: "fa-rotate-reverse", link: "/settings/default/note-types" },
        { title: t('languages.title'), icon: "fa-globe", link: "/settings/languages/languages" },
        { title: t('calendar.title'), icon: "fa-calendar-lines", link: "/settings/calendar/holidays" },
        { title: t('reports.title'), icon: "fa-clipboard-list", link: "/settings/reports/types", disabled: true },
        { title: t('locations.title'), icon: "fa-location-dot", link: "/settings/locations/locations" },
        { title: t('employees.title'), icon: "fa-user-tie", link: "/settings/employees/roles" },
        { title: t('groups.title'), icon: "fa-users", link: "/settings/groups/plans" },
        { title: t('students.title'), icon: "fa-user-graduate", link: "/settings/students/schools" },
        { title: t('calls.title'), icon: "fa-phone", link: "/settings/calls/appointments" },
    ];

    const [{ getDecoded }] = useUserToken();
    const decodedToken = getDecoded();
    const userRoles = decodedToken?.roles || [];

    const isProfessorCoordinator = userRoles.includes(roles.PROFESSOR_COORDINATOR);
    const isDirectorOfStudy = userRoles.includes(roles.DIRECTOR_OF_STUDIES);

    let filteredButtons = buttons;

    if (isProfessorCoordinator) {
        filteredButtons = buttons.filter(b => b.link === "/settings/groups/plans");
    } else if (isDirectorOfStudy) {
        const allowedLinks = [
            "/settings/languages/languages",
            "/settings/calendar/holidays",
            "/settings/reports/types",
            "/settings/groups/plans"
        ];
        filteredButtons = buttons.filter(b => allowedLinks.includes(b.link));
    }

    return (
        <DefaultLayout>
            <TopNavigation />
            <Main>
                <Title>{t('settings.title')}</Title>
                <Breadcrumps>
                    <Link title={t('settings.title')} icon="fa-gear"/>
                    <Link title={t('settings.list')} isActive={true}/>
                </Breadcrumps>
                <ButtonsPanel buttons={filteredButtons} />
            </Main>
        </DefaultLayout>
    );
};

export default Settings;
